/* eslint-disable no-console */
import log from 'loglevel';
import { map, partial } from 'lodash';

export const LOG_LEVELS = {
    TRACE: 'trace',
    DEBUG: 'debug',
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error',
    SILENT: 'silent',
};

function getLevelName(level) {
    switch (level) {
        case log.levels.TRACE:
            return LOG_LEVELS.TRACE;
        case log.levels.DEBUG:
            return LOG_LEVELS.DEBUG;
        case log.levels.INFO:
            return LOG_LEVELS.INFO;
        case log.levels.WARN:
            return LOG_LEVELS.WARN;
        case log.levels.ERROR:
            return LOG_LEVELS.ERROR;
        case log.levels.SILENT:
            return LOG_LEVELS.SILENT;
        default:
            console.error(`unknown`);
    }
}

function listLoggers(loggers = log.getLoggers()) {
    console.table(
        map(loggers, (aLogger, name) => {
            return {
                name,
                level: getLevelName(aLogger.getLevel()),
            };
        })
    );
}

function setLogLevel(loggerName, level) {
    const loggers = log.getLoggers();
    const logger = loggers[loggerName];

    if (logger) {
        logger.setLevel(level);
        console.log(`Logger ${loggerName} level set to ${level}`);
    } else {
        console.error(`Unknown logger ${loggerName}`);
        console.log('Current Loggers');
        listLoggers(loggers);
    }
}

// This enables controlling log levels from the console:
//
// > setLogLevel('MyComponent', LOG_LEVELS.DEBUG);
//
window.LOG_LEVELS = LOG_LEVELS;
window.setLogLevel = setLogLevel;

// This enables listing loggers from the console:
//
// > listLoggers();
//
window.listLoggers = listLoggers;

export function getLogger(name) {
    const logger = log.getLogger(name);

    function table(level, msg) {
        if (logger.getLevel() <= level) {
            console.table(msg);
        }
    }

    function logFn(level, msg) {
        switch (level) {
            case log.levels.TRACE:
                return logger.trace(msg);
            case log.levels.DEBUG:
                return logger.debug(msg);
            case log.levels.INFO:
                return logger.info(msg);
            case log.levels.WARN:
                return logger.warn(msg);
            case log.levels.ERROR:
                return logger.error(msg);
            default:
                console.error(`Unknown log level ${level}`);
        }
    }

    return {
        name,
        levels: log.levels,
        getLevel: () => logger.getLevel(),
        setLevel: (level) => logger.setLevel(level),
        isTraceEnabled: () => logger.getLevel() <= log.levels.TRACE,
        isDebugEnabled: () => logger.getLevel() <= log.levels.DEBUG,
        isInfoEnabled: () => logger.getLevel() <= log.levels.INFO,
        isWarnEnabled: () => logger.getLevel() <= log.levels.WARN,
        isErrorEnabled: () => logger.getLevel() <= log.levels.ERROR,
        trace: partial(logFn, log.levels.TRACE),
        traceTable: partial(table, log.levels.TRACE),
        debug: partial(logFn, log.levels.DEBUG),
        debugTable: partial(table, log.levels.DEBUG),
        info: partial(logFn, log.levels.INFO),
        infoTable: partial(table, log.levels.INFO),
        warn: partial(logFn, log.levels.WARN),
        warnTable: partial(table, log.levels.WARN),
        error: partial(logFn, log.levels.ERROR),
        errorTable: partial(table, log.levels.ERROR),
    };
}
